<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} phản ánh
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="4">
                    <el-form-item label="Người gửi">
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="nguoiGui"
                        :fetch-suggestions="querySearchNguoiGui"
                        placeholder="Nhập từ khóa để tìm kiếm"
                        :trigger-on-focus="false"
                        @select="handleSelectNguoiGui"
                        @change="handleSelectNguoiGui"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <el-form-item
                      label="Ngày phản ánh"
                      prop="thoi_diem_phan_hoi"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_diem_phan_hoi
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col
            :class="
              aRole('TCQLTT') || aRole('Admin') ? 'col-md-10' : 'col-md-8'
            "
          >
            <div class="text-left mb-0">
              <b-row>
                <!-- Ẩn nhóm phản ánh task #173668
                <b-col
                  :class="aRole('TCQLTT') ? 'col-md-3' : 'col-md-4'"
                  v-if="aRole('Admin') || aRole('Officer')"
                >
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.loai_phan_hoi"
                    :placeholder="'Loại nhóm phản ánh'"
                    @change="fn_tableSearch()"
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listLoaiNhomPhanHoiTable"
                      :key="item.key"
                      :label="item.text"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col :class="aRole('TCQLTT') ? 'col-md-3' : 'col-md-4'">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.nhom_phan_hoi"
                    :placeholder="'Nhóm phản ánh'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listNhomPhanHoiTable.filter(
                        (x) =>
                          x.loai ==
                          mData.tableRules.dataSearch.value.loai_phan_hoi
                      )"
                      :key="item.id"
                      :label="item.ten.vi"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </b-col> -->
                <b-col class="col-md-4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.trang_thai"
                    :placeholder="'Trạng thái'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.trangThai"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col
            :class="aRole('TCQLTT') || aRole('Admin') ? 'col-md-2' : 'col-md-4'"
          >
            <div class="text-right mb-2">
              <el-button
                @click="fn_SendTcqltt()"
                type="danger"
                plain
                :disabled="mData.dataDefault.countPhanHois <= 0"
                v-if="aRole('Officer') || aRole('Admin')"
                >{{ aLang.c_sendTcqltt }}</el-button
              >
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          v-loading="mData.dataDefault.tableLoading"
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          default-expand-all
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column
            prop="selectedToSend"
            label="Chọn"
            width="60"
            align="center"
            v-if="aRole('Officer') || aRole('Admin')"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.selectedToSend"
                @change="fn_changeSelectedToSend(scope.row.selectedToSend)"
                v-if="
                  scope.row.trang_thai !== 'forwarded_to_tcqltt' &&
                  scope.row.allowSend == true
                "
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_nguoi_gui"
            :sortable="mData.tableRules.allowSorting"
            label="Người gửi"
            width="180"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false"
                >{{
                  scope.row.ten_nguoi_gui && scope.row.ten_nguoi_gui.trim()
                    ? scope.row.ten_nguoi_gui
                    : "Chưa cập nhật thông tin"
                }}</el-link
              >
              <p
                class="m-0 p-0 text-primary"
                v-if="aRole('Officer') || aRole('Admin')"
              >
                {{
                  scope.row.tcqltt && scope.row.tcqltt.nguoi_xu_ly_id
                    ? scope.row.tcqltt.ten_nguoi_xu_ly
                    : ""
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="dien_thoai"
            label="Số điện thoại"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="email"
            label="Email"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="so_the"
            label="Số thẻ"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="noi_dung"
            :sortable="mData.tableRules.allowSorting"
            label="Nội dung"
            width="auto"
            min-width="150"
          >
            <template slot-scope="scope">
              <p class="m-0 p-0">{{ scope.row.noi_dung }}</p>
              <p
                class="m-0 p-0 text-primary"
                v-if="aRole('Officer') || aRole('Admin')"
              >
                {{
                  scope.row.tcqltt &&
                  scope.row.tcqltt.lich_su &&
                  scope.row.tcqltt.lich_su.length > 0
                    ? scope.row.tcqltt.lich_su[
                        scope.row.tcqltt.lich_su.length - 1
                      ].ly_do
                    : ""
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Hình ảnh" width="100" align="center">
            <template slot-scope="scope">
              <div
                class="ico"
                v-if="
                  scope.row.file_dinh_kem && scope.row.file_dinh_kem.length > 0
                "
                title="Xem chi tiết"
                @click="showDetailImage(scope.row.file_dinh_kem)"
              >
                <i
                  class="fas fa-image"
                  style="font-size: 20px; cursor: pointer"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="thoi_diem_phan_hoi"
            :sortable="mData.tableRules.allowSorting"
            label="Thời gian"
            :formatter="fn_formatterDatetime"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <p class="m-0 p-0">
                {{ fn_formatterDatetimeList(scope.row.thoi_diem_phan_hoi) }}
              </p>
              <p
                class="m-0 p-0 text-primary"
                v-if="aRole('Officer') || aRole('Admin')"
              >
                {{
                  scope.row.tcqltt &&
                  scope.row.tcqltt.lich_su &&
                  scope.row.tcqltt.lich_su.length > 0
                    ? fn_formatterDatetimeList(
                        scope.row.tcqltt.lich_su[
                          scope.row.tcqltt.lich_su.length - 1
                        ].thoi_diem
                      )
                    : ""
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_trang_thai"
            :sortable="mData.tableRules.allowSorting"
            label="Trạng thái"
            min-width="170"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="fn_getTrangThaiType(scope.row.trang_thai)"
                size="small"
                v-if="scope.row.ten_trang_thai"
                >{{ scope.row.ten_trang_thai }}</el-tag
              >
              <p
                class="m-0 p-0 mt-1"
                v-if="
                  (aRole('Officer') || aRole('Admin')) &&
                  scope.row.ten_trang_thai_duyet
                "
              >
                <el-tag type="info" size="mini">{{
                  scope.row.ten_trang_thai_duyet
                }}</el-tag>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_trang_thai_duyet"
            :sortable="mData.tableRules.allowSorting"
            label="Trạng thái"
            width="120"
            align="center"
            v-if="aRole('TCQLTT')"
          ></el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('updateTcqltt', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_changeStatus"
                v-if="aRole('TCQLTT')"
                :disabled="!scope.row.allowChange == true"
              >
                <i class="icon-refresh"></i>
              </el-button>

              <el-dropdown
                trigger="click"
                class="mr-2"
                @command="fn_changeTrangThai"
                v-if="
                  !aRole('TCQLTT') &&
                  (aRole('Admin') ||
                    aRole('VNATAdmin') ||
                    aRole('Officer') ||
                    aRole('TourAgent'))
                "
              >
                <el-button
                  size="mini"
                  v-b-popover.hover.left="aLang.c_changeStatus"
                  :disabled="
                    scope.row.trang_thai == 'forwarded_to_tcqltt' &&
                    !aRole('Admin')
                  "
                >
                  <i class="icon-refresh"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in mData.dataDefault.listTrangThai"
                    :key="item.code"
                    :command="fn_mergeTrangThai(scope.row, item.code)"
                    >{{ item.text }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>

              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('Admin,Officer,TourAgent')"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <!-- Dialog chi tiết ảnh -->
    <el-dialog
      title="Chi tiết"
      :visible.sync="imageDialogVisible"
      width="40%"
      :before-close="handleCloseImageDialog"
      :close-on-click-modal="false"
    >
      <el-carousel height="500px">
        <el-carousel-item
          v-for="item in mData.dataDefault.listImages"
          :key="item"
        >
          <img :src="item" alt="image" style="object-fit: cover" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import PhanHoiModel from "./PhanHoiModel";
import mushroom from "../../../service/api/dulich-api";
import ApiService from "@/service/ApiService";
import DataService from "@/service/DataService";
// import MailingService from "@/service/MailingService";
import ExtensionService from "@/service/ExtensionService";
import config from "../../../config.json";

export default {
  data() {
    return {
      imageDialogVisible: false,
      nguoiGui: "",
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "detail",
        moduleName: "PhanHoi",
        dataDefault: {
          roles: DataService.roles,
          listImages: [],
          listTour: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listNhomPhanHoi: [],
          listNhomPhanHoiTable: [],
          // listLoaiNhomPhanHoiTable: [
          //   { key: "kdl", text: "Khách du lịch" },
          //   { key: "hdv", text: "Hướng dẫn viên" },
          //   { key: "ddat", text: "Điểm đến" },
          //   { key: "trang_vang", text: "Trang vàng" },
          // ],
          textFindNguoiXuLy: "",
          listFindNguoiXuLy: [],
          dataNguoiXuLy: [],
          listLoaiNhomPhanHoi: DataService.loaiNhomPhanHoi,
          textFindNguoiGui: "",
          listNguoiGui: [],
          listFindNguoiGui: [],
          itemNguoiGui: null,
          loai_phan_hoi: null,
          trangThai: MethodService.copyObject(PhanHoiModel.trangThai),
          listTrangThai: MethodService.copyObject(PhanHoiModel.trangThai),
          trangThaiTcqltt: PhanHoiModel.trangThaiTcqltt,
          nguoiXuLyTCQLTT: "",
          listTCQLTT: [],
          countPhanHois: 0,
          firstLoad: true,
          listDoiTuongPhanHoi: MethodService.copyObject(
            DataService.doiTuongPhanHoi
          ),
          dataForDialog: null,
          dialog: false,
          tableLoading: false,
        },
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        ifHavePermission: false,
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        tableRules: MethodService.copyObject(PhanHoiModel.tableRules),
        validForm: PhanHoiModel.validForm,
      },
    };
  },
  // watch: {
  //   "mData.tableRules.dataSearch.value.loai_phan_hoi": function () {
  //     this.mData.tableRules.dataSearch.value.nhom_phan_hoi = "";
  //     this.$forceUpdate();
  //   },
  // },
  methods: {
    showDetailImage(idsImage) {
      this.mData.dataDefault.listImages = [];
      for (const id of idsImage) {
        if (!id) continue;
        const imageUrl = ExtensionService.urlImg + id;
        this.mData.dataDefault.listImages.push(imageUrl);
      }
      this.imageDialogVisible = true;
    },
    handleCloseImageDialog() {
      this.imageDialogVisible = false;
    },

    async fn_initData() {
      this.mData.dataDefault.tableLoading = true;
      try {
        let currentUser = MethodService.getCurrentUser();
        let stringFilter = "";
        let nhomPhanHoiFilter = "";
        if (
          MethodService.checkRole("TCQLTT") &&
          !MethodService.checkRole("TCQLTTP") &&
          this.mData.dataDefault.firstLoad
        ) {
          if (
            !this.mData.tableRules.filters.includes("tcqltt.nguoi_xu_ly_id:in:")
          ) {
            stringFilter = "tcqltt.nguoi_xu_ly_id:in:" + currentUser.id;
            this.mData.dataDefault.dataNguoiXuLy.push(currentUser.id);
          }
          this.mData.dataDefault.firstLoad = false;
        } else if (MethodService.checkRole("TourAgent")) {
          stringFilter =
            "cong_ty_lu_hanh_id:is_null:false&cong_ty_lu_hanh_id=$$cong_ty_lu_hanh_id";
        }

        let dataFilter = {
          filters:
            (stringFilter ? stringFilter.trim() + "&" : "") +
            this.mData.tableRules.filters,
        };

        if (this.mData.tableRules.allowSorting) {
          dataFilter.sort = this.mData.tableRules.sort;
        }
        if (this.mData.tableRules.showUrl) {
          this.$router
            .replace({
              name: "Admin-" + this.mData.moduleName + "-list",
              query: {
                limit: this.mData.tableRules.limit,
                page: this.mData.tableRules.page,
                sort: this.mData.tableRules.sort,
                filters: this.mData.tableRules.filters,
                showFormSearch: this.mData.tableRules.showFormSearch,
              },
            })
            .catch(() => {});
        }
        let res = await mushroom.phan_hoi.listAsync({
          filters: dataFilter.filters,
          limit: this.mData.tableRules.limit,
          offset: this.mData.tableRules.offset,
          fields:
            "id,nguoi_gui_id,thoi_diem_phan_hoi,nhom_phan_hoi,cong_ty_lu_hanh_id,diem_den_an_toan_id,tour_id,doi_tuong_phan_hoi,noi_dung,file_dinh_kem,trang_thai,lich_su,tcqltt.trang_thai,loc",
        });
        if (res.result) {
          let resData = MethodService.checkDifferentObject(
            MethodService.copyObject(PhanHoiModel.dataForm),
            res.result
          );
          let nguoiGuiIds = [];
          let nguoiXuLyIds = [];
          nguoiGuiIds = MethodService.findListItemDifferent(
            resData,
            "nguoi_gui_id"
          );
          // lấy id nguoi xu ly
          let arrNguoiXuLy = [];
          resData.forEach((item) => {
            if (item.tcqltt && item.tcqltt.nguoi_xu_ly_id) {
              arrNguoiXuLy.push(item.tcqltt.nguoi_xu_ly_id);
            }
          });
          nguoiXuLyIds = MethodService.findListItemDifferent(arrNguoiXuLy);
          let reqKhachDuLichApi = mushroom.khach_du_lich.listAsync({
            limit: nguoiGuiIds.length,
            filters: "id:in:" + nguoiGuiIds.join(","),
          });
          let reqNguoiXuLyApi = mushroom.profile.listAsync({
            limit: nguoiXuLyIds.length,
            filters: "id:in:" + nguoiXuLyIds.join(","),
          });
          let reqHuongDanVienApi = mushroom.huong_dan_vien.listAsync({
            limit: nguoiGuiIds.length,
            filters: "id:in:" + nguoiGuiIds.join(","),
          });

          let resKhachDuLichApi = await reqKhachDuLichApi;
          let resNguoiXuLyApi = await reqNguoiXuLyApi;
          let resHuongDanVienApi = await reqHuongDanVienApi;

          this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
          this.mData.dataDefault.listNguoiXuLy = resNguoiXuLyApi.result;
          this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;

          resData.forEach(async (item) => {
            let tenNhomPhanHoi =
              this.mData.dataDefault.listNhomPhanHoiTable.find((element) => {
                return element.id == item.nhom_phan_hoi;
              });
            let nguoiGuiKhachDL = this.mData.dataDefault.listKhachDuLich.find(
              (element) => {
                return element.id == item.nguoi_gui_id;
              }
            );
            if (nguoiGuiKhachDL) {
              if (nguoiGuiKhachDL.ho_ten && nguoiGuiKhachDL.ho_ten.ho_ten) {
                item.ten_nguoi_gui = nguoiGuiKhachDL.ho_ten.ho_ten;
              }
              item.dien_thoai = nguoiGuiKhachDL.dien_thoai;
              item.email = nguoiGuiKhachDL.email;
              item.so_the = nguoiGuiKhachDL.so_the;
            } else {
              let nguoiGuiHDV = this.mData.dataDefault.listHuongDanVien.find(
                (element) => {
                  return element.id == item.nguoi_gui_id;
                }
              );
              if (nguoiGuiHDV) {
                item.ten_nguoi_gui = nguoiGuiHDV.ho_ten.ho_ten;
                item.dien_thoai = nguoiGuiHDV.dien_thoai;
              }
            }

            let tenTrangThai = this.mData.dataDefault.trangThai.find(
              (element) => {
                return element.code == item.trang_thai;
              }
            );
            if (tenTrangThai) {
              item.ten_trang_thai = tenTrangThai.text;
            } else {
              item.ten_trang_thai = "";
            }
            if (item.tcqltt && item.tcqltt.trang_thai) {
              let tenTrangThaiDuyet =
                this.mData.dataDefault.trangThaiTcqltt.find((element) => {
                  return element.code == item.tcqltt.trang_thai;
                });
              if (tenTrangThaiDuyet) {
                item.ten_trang_thai_duyet = tenTrangThaiDuyet.text;
              } else {
                item.ten_trang_thai_duyet = "";
              }
            } else {
              item.ten_trang_thai_duyet = "";
            }

            if (this.aRole("TCQLTT")) {
              if (currentUser.id == item.tcqltt.nguoi_xu_ly_id) {
                item.allowChange = true;
              }
            }
            if (tenNhomPhanHoi) {
              item.ten_nhom_phan_hoi = tenNhomPhanHoi.ten.vi;
              item.allowSend = tenNhomPhanHoi.chuyen_tcqltt;
            } else {
              item.ten_nhom_phan_hoi = "";
              item.allowSend = false;
            }

            if (item.tcqltt && item.tcqltt.nguoi_xu_ly_id) {
              let tenNXL = this.mData.dataDefault.listNguoiXuLy.find(
                (element) => {
                  return element.id == item.tcqltt.nguoi_xu_ly_id;
                }
              );
              if (tenNXL) {
                item.tcqltt.ten_nguoi_xu_ly = tenNXL.ho_ten.ho_ten;
              } else {
                item.tcqltt.ten_nguoi_xu_ly = "";
              }
            }
          });
          await Promise.resolve(this.fn_changeData(resData));
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = res.meta.total;
          this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
          if (
            this.mData.tableRules.offset == res.meta.total &&
            this.mData.tableRules.offset != 0
          ) {
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.page = 1;
            this.fn_initData();
          }
        }
      } finally {
        this.mData.dataDefault.tableLoading = false;
      }
    },
    removeQueryParam(key, queryStringCheck) {
      let result = queryStringCheck.split("?")[0],
        param,
        params_arr = [],
        queryString =
          queryStringCheck.indexOf("?") !== -1
            ? queryStringCheck.split("?")[1]
            : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        result = result + "?" + params_arr.join("&");
      }
      return result;
    },
    async fn_findNguoiGui() {
      this.mData.dataDefault.textFindNguoiGui =
        this.mData.dataDefault.textFindNguoiGui.trim();
      if (!this.mData.dataDefault.textFindNguoiGui) {
        return;
      }
      this.mData.dataDefault.listFindNguoiGui = [];
      mushroom.phan_hoi.views
        .suggest_response_userAsync({
          name: this.mData.dataDefault.textFindNguoiGui,
        })
        .then(async (suggestUser) => {
          if (suggestUser.result && suggestUser.result.length > 0) {
            this.mData.dataDefault.listFindNguoiGui = suggestUser.result;
          }
        });
    },
    async fn_remoteGetListNguoiGui(query) {
      this.mData.dataDefault.textFindNguoiGui = query;
    },
    async fn_enterFindNguoiGui() {
      if (!this.mData.dataDefault.textFindNguoiGui) {
        return;
      }
      let resKhachDuLichApi = await mushroom.khach_du_lich.listAsync({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindNguoiGui}`,
      });
      this.mData.dataDefault.listNguoiGui = resKhachDuLichApi.result;
    },
    //search
    async querySearchNguoiGui(queryString, cb) {
      queryString = queryString.trim();
      await mushroom.phan_hoi.views
        .suggest_response_userAsync({
          name: queryString,
        })
        .then(async (suggestUser) => {
          if (suggestUser.result && suggestUser.result.length > 0) {
            this.mData.dataDefault.listFindNguoiGui = suggestUser.result;
          }
        });
      let results = queryString
        ? this.mData.dataDefault.listFindNguoiGui.filter((item) =>
            item.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listFindNguoiGui;
      cb(results);
    },
    handleSelectNguoiGui(item) {
      this.mData.tableRules.dataSearch.value.nguoi_gui_id = item.nguoi_gui_id;
      this.nguoiGui = item.ho_ten;
    },
    async getTenDoiTuongPhanHoi(doiTuongPhanHoi) {
      if (!doiTuongPhanHoi) {
        return "";
      }
      try {
        if (this.mData.tableRules.dataSearch.value.loai_phan_hoi != "ddat") {
          switch (doiTuongPhanHoi.doi_tuong) {
            case "DDAT":
              if (doiTuongPhanHoi.doi_tuong_con_id) {
                let response = await mushroom.tv_dich_vu.findByIdAsync({
                  id: doiTuongPhanHoi.doi_tuong_con_id,
                });
                if (response.result) {
                  if (response.result.diem_den) {
                    return response.result.diem_den.ten;
                  } else if (response.result.luu_tru) {
                    return response.result.luu_tru.ten;
                  } else if (response.result.giai_tri) {
                    return response.result.giai_tri.ten;
                  } else if (response.result.am_thuc) {
                    return response.result.am_thuc.ten;
                  } else {
                    return "";
                  }
                }
              } else {
                return "";
              }
              break;
            case "DNLH":
              if (doiTuongPhanHoi.doi_tuong_con_id) {
                let response = await mushroom.tv_dich_vu_tour.findByIdAsync({
                  id: doiTuongPhanHoi.doi_tuong_con_id,
                });
                return response.result
                  ? response.result.ten_tour
                  : "Chưa có thông tin";
              } else {
                return "";
              }
            default:
              return "";
          }
        } else {
          if (doiTuongPhanHoi.doi_tuong_id) {
            let response = await mushroom.diem_den_an_toan.findByIdAsync({
              id: doiTuongPhanHoi.doi_tuong_id,
            });
            return response.result
              ? response.result.thong_tin_chung.ten
              : "Chưa có thông tin";
          } else {
            return "";
          }
        }
      } catch (e) {
        console.info(e);
        return "";
      }
    },
    async getTenDonViPhanHoi(doiTuongPhanHoi) {
      if (!doiTuongPhanHoi) {
        return "";
      }
      try {
        switch (doiTuongPhanHoi.doi_tuong) {
          case "DDAT":
            if (doiTuongPhanHoi.doi_tuong_id) {
              let donViResponse = await mushroom.diem_den_an_toan.listAsync({
                filters: `nguoi_tao_id=${doiTuongPhanHoi.doi_tuong_id}`,
              });
              return donViResponse.result && donViResponse.result.length > 0
                ? donViResponse.result[0].thong_tin_chung.ten
                : "Chưa có thông tin";
            } else {
              return "";
            }
          case "DNLH":
            if (doiTuongPhanHoi.doi_tuong_id) {
              let donViResponse = await mushroom.cong_ty_lu_hanh.listAsync({
                filters: `nguoi_quan_ly_ids=${doiTuongPhanHoi.doi_tuong_id}`,
              });
              return donViResponse.result &&
                donViResponse.result.length > 0 &&
                donViResponse.result[0].ten
                ? donViResponse.result[0].ten.vi
                : "Chưa có thông tin";
            } else {
              return "";
            }
          default:
            return "";
        }
      } catch (e) {
        console.info(e);
        return "";
      }
    },

    async getNhomPhanHoi() {
      let data = await mushroom.nhom_phan_hoi.listAsync({ limit: 1000 });
      if (data.result) {
        this.mData.dataDefault.listNhomPhanHoiTable = data.result;
        await this.fn_initData();
      }
    },

    asyncMap(array, callback) {
      let promise = Promise.resolve();
      return Promise.all(
        array.map((x) => (promise = promise.then(() => callback(x))))
      );
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return new Promise((resolve) => {
        let promise = this.asyncMap(resData, async (row) => {
          row.ten_don_vi = await this.getTenDonViPhanHoi(
            row.doi_tuong_phan_hoi
          );
          row.ten_doi_tuong_phan_hoi = await this.getTenDoiTuongPhanHoi(
            row.doi_tuong_phan_hoi
          );
          return row;
        });
        resolve(promise);
      });
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initData();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let stringFilter = "";
          let nhomPhanHoiFilter = "";
          if (
            this.mData.dataDefault.dataNguoiXuLy &&
            this.mData.dataDefault.dataNguoiXuLy.length > 0
          ) {
            stringFilter = "tcqltt.nguoi_xu_ly_id:in:";
            this.mData.dataDefault.dataNguoiXuLy =
              MethodService.findListItemDifferent(
                this.mData.dataDefault.dataNguoiXuLy
              );
            this.mData.dataDefault.dataNguoiXuLy.map((nxl, index) => {
              if (index == this.mData.dataDefault.dataNguoiXuLy.length - 1) {
                stringFilter += nxl;
              } else {
                stringFilter += nxl + ",";
              }
            });
            stringFilter += "&";
          }

          // if (!this.mData.tableRules.filters.includes("nhom_phan_hoi=")) {
          //   if (
          //     this.mData.dataDefault.listNhomPhanHoiTable.filter(
          //       (x) => x.loai == this.mData.loai_phan_hoi
          //     ).length > 0
          //   ) {
          //     nhomPhanHoiFilter =
          //       "nhom_phan_hoi:in:" +
          //       this.mData.dataDefault.listNhomPhanHoiTable
          //         .filter((x) => x.loai == this.mData.loai_phan_hoi)
          //         .map((x) => x.id)
          //         .join(",");
          //   }
          // }

          let dataFilter = {
            filters:
              stringFilter.trim() +
              // nhomPhanHoiFilter.trim() +
              this.mData.tableRules.filters,
          };

          if (this.mData.tableRules.allowPaging) {
            dataFilter.limit = this.mData.tableRules.limit;
            dataFilter.offset = this.mData.tableRules.offset;
          }
          if (this.mData.tableRules.allowSorting) {
            dataFilter.sort = this.mData.tableRules.sort;
          }

          this.mData.tableRules.filters =
            stringFilter +
            MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initData();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initData();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },
    fn_changeSelectedToSend(selectedValue) {
      if (selectedValue) {
        this.mData.dataDefault.countPhanHois++;
      } else {
        this.mData.dataDefault.countPhanHois--;
      }
    },

    async fn_SendTcqltt() {
      let resNguoiXuLyTCQLTT = await mushroom.config.listAsync({
        filters: "code:in:default_user_tcqltt_id",
      });
      if (resNguoiXuLyTCQLTT.result && resNguoiXuLyTCQLTT.result.length > 0) {
        this.mData.dataDefault.nguoiXuLyTCQLTT =
          resNguoiXuLyTCQLTT.result[0].value;
      }
    },

    async fn_changeTrangThai(command) {
      let data = {
        id: command.id,
        trang_thai: command.trangThaiNew,
      };
      await mushroom.phan_hoi.partialUpdateAsync(data).then(async (res) => {
        if (res.result) {
          this.fn_initData();
          this.$store.commit("fn_countPhanHoi");
        }
      });
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_formatterDatetimeList(cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_getTrangThaiType(trangThai) {
      switch (trangThai) {
        case "new":
          return "danger";
        case "processing":
          return "warning";
        case "processed":
          return "success";
        case "forwarded_to_tcqltt":
          return "";
        default:
          return "info";
      }
    },

    //thêm trangThaiNew vào object
    fn_mergeTrangThai(row, status) {
      let object = MethodService.copyObject(row);
      object.trangThaiNew = status;
      return object;
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    async fn_delete(id) {
      await mushroom.phan_hoi.deleteAsync(id);
      this.fn_initData();
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        let cacheArray = this.mData.tableRules.filters.split("&");
        for (let item of cacheArray) {
          if (item.includes("tcqltt.nguoi_xu_ly_id:in:")) {
            let string = item.replace("tcqltt.nguoi_xu_ly_id:in:", "");
            this.mData.dataDefault.dataNguoiXuLy = string.split(",");
            let resNguoiGui = await mushroom.profile.listAsync({
              limit: 1000,
              filters: `id:in:${string}`,
            });
            this.mData.dataDefault.listFindNguoiXuLy = resNguoiGui.result;
            let index = cacheArray.indexOf(item);
            cacheArray.splice(index, 1);
          }
        }
        let stringFilter = cacheArray.join("&");

        // string to object
        if (stringFilter.trim() != "") {
          this.mData.tableRules.dataSearch.value =
            MethodService.stringToObject(stringFilter);
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.mData.tableRules.dataSearch.value.nguoi_gui_id) {
        let resKhachDL = await mushroom.khach_du_lich.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.nguoi_gui_id,
        });
        if (resKhachDL.result) {
          this.mData.dataDefault.listFindNguoiGui.push(resKhachDL.result);
          this.nguoiGui = resKhachDL.result.ho_ten.ho_ten;
        } else {
          let resHDV = await mushroom.huong_dan_vien.findByIdAsync({
            id: this.mData.tableRules.dataSearch.value.nguoi_gui_id,
          });
          if (resHDV.result) {
            this.mData.dataDefault.listFindNguoiGui.push(resHDV.result);
            this.nguoiGui = resHDV.result.ho_ten.ho_ten;
          }
        }
      }
    },
    fn_delay(callback, ms) {
      let timer = 0;
      return function () {
        let context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    },
  },
  created: async function () {
    if (this.mData.currentUser.roles.includes("Officer", "Admin")) {
      this.mData.ifHavePermission = true;
    }
    // if (this.aRole("TourAgent") || this.aRole("SafePlace")) {
    //   this.mData.tableRules.dataSearch.value.loai_phan_hoi = "trang_vang";
    // }
    await this.getNhomPhanHoi();
    this.$store.commit("fn_countPhanHoi");
    this.fn_hashUrl();
  },
};
</script>
<style>
.el-autocomplete.inline-input {
  width: 100%;
}
</style>
